import { styled } from "@mui/system";
import { Container, Box, Button, ListItem, List } from "@mui/material";
import LinearProgress, {
  linearProgressClasses,
} from "@mui/material/LinearProgress";
import StyledFrame from "react-styled-frame";

export const SubmitButton = styled(Button)(({ theme }) => ({
  backgroundColor: "#000000",
  // left: "55%",
  marginRight: "1rem",
}));

export const HintsButton = styled(Button)(({ theme }) => ({
  color: "#000000",
  // left: "100%",
}));

export const SolutionButton = styled(Button)(({ theme }) => ({
  color: "#000000",
  // left: "90%",
}));

export const NextButton = styled(Button)(({ theme }) => ({
  backgroundColor: "white",
  border: "1px solid black",
  color: "black",
  // left: "60%",
}));

export const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
  height: 10,
  borderRadius: 5,
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor: "#B6B4B3",
    ...theme.applyStyles("dark", {
      backgroundColor: "#B6B4B3",
    }),
  },
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: 5,
    backgroundColor: "#000000",
    ...theme.applyStyles("dark", {
      backgroundColor: "#000000",
    }),
  },
}));

export const VideoList = styled(List)(({ theme }) => ({
  maxHeight: "600px",
  minWidth: "700px",
  overflowY: "scroll",
}));

// export const StyledIframe = styled(StyledFrame)``;
